<template>
  <div class="home">
    <a-row class="home-head"> 
      <a-col :span="8">
        <p>{{TroopInfo.TroopsName==null || TroopInfo.TroopsName==undefined ? '数据监控' : TroopInfo.TroopsName}}
        	<img src="../assets/images/icon_groupretreat_selected.png" @click="groupRetreat" style="width: 46px;position: absolute;right: 30px;top: 7px;cursor: pointer;" v-if="groupRetreatImg"/>
          <img src="../assets/images/icon_groupretreat.png" @click="groupRetreat" style="width: 46px;position: absolute;right: 30px;top: 7px;cursor: pointer;z-index: 1;" v-else/>
        </p>
      </a-col> 
      <a-col :span="16">
        <p>地图
          <span id="reset-btn" style="float:right;font-size: 18px;margin: 20px 30px 0 0; padding:1px 12px;color:#fff;background:#40DC23;border-radius: 20px;cursor: pointer;" @click="clickReset">重置轨迹</span>   
        </p>   
      </a-col> 
    </a-row>
    <a-row class="home-body">
      <a-col style="width:33%;float: left;min-height: 83vh;" @touchstart="touchSatrt" @touchmove="touchMove" @touchend="touchEnd">    
        <a-collapse id="home-content" v-if="groups.length!=0">
        	<ul class="home-group">
        		<li v-for="(group,index) in groups" :class="{selected:groupIndex == index}" @click="getTeamByGroup(group,index)">{{group}}</li>  
        	</ul> 
          <a-collapse-panel v-for="(item,index) in TeamMemberLists" v-show="item.GroupName==group && item.isInit">
            <template slot="header" >
              <div class="team-info" @dblclick="call(item.SN)" :sn="item.SN">  
                <!-- 定位器姿势图片 --> 
              	<span>  
              		<img src="../assets/images/card_notonline.png" v-if="item.isOnLine"/>  
              		<img src="../assets/images/card_stand.gif" v-else-if="item.Location==null"/> 
              		<img src="../assets/images/card_stand.gif" v-else-if="item.Location.Posture==42"/> 
              		<img src="../assets/images/card_walk.gif" v-else-if="item.Location.Posture==43"/> 
              		<img src="../assets/images/card_run.gif" v-else-if="item.Location.Posture==44"/>
              		<img src="../assets/images/card_cramb.gif" v-else-if="item.Location.Posture==45"/>
              		<img src="../assets/images/card_strair_up.gif" v-else-if="item.Location.Posture==46"/>
              		<img src="../assets/images/card_strair_down.gif" v-else-if="item.Location.Posture==47"/>  
              		<img src="../assets/images/card_lie_side.gif" v-else-if="item.Location.Posture==49"/>
              		<img src="../assets/images/card_lie_down.gif" v-else-if="item.Location.Posture==50"/>
                  <img src="../assets/images/card_lie_up.gif" v-else-if="item.Location.Posture==51"/> 
                  <img src="../assets/images/card_lie_side.gif" v-else-if="item.Location.Posture==52"/>
              		<img src="../assets/images/card_stand.gif" v-else/> 
              	</span>
                <!-- 呼救器状态图标 -->
              	<span>  
              		<img src="../assets/images/icon_alarm_notonline_64.png" v-if="item.isOnLine"/>
              		<img src="../assets/images/icon_alarm_normal_64.png" v-else-if="item.AlarmStatus==0"/>
              		<img src="../assets/images/home_icon_recco_manualalert.png" v-else-if="item.AlarmStatus==3"/>
              		<img src="../assets/images/home_icon_recco_alarmstrong.png" v-else-if="item.AlarmStatus==4"/>
              		<img src="../assets/images/home_icon_recco_strongalert.png" v-else-if="item.AlarmStatus==6 || item.AlarmStatus==7"/>
              		<img src="../assets/images/icon_alarm_normal_64.png" v-else/>
              		<br>
              		{{item.Name}} 
              	</span>   
                <!-- 呼救器撤离状态图标 -->    
                <span @click="retreat($event,index,item.SN)" v-if="(IsResponse[item.SN] && !item.isOnLine) || (item.AlarmStatus==18 && !item.isOnLine)">
                  <img src="../assets/images/icon_retreat_selected.png"/><br/>
                  已响应
                </span>  
                <span @click="retreat($event,index,item.SN)" v-else-if="IsResponse[item.SN] || item.AlarmStatus==18">
                  <img src="../assets/images/icon_retreat.png"/><br/>
                  已响应
                </span> 
              	<span @click="retreat($event,index,item.SN)" v-if="item.AlarmStatus==7 && !item.isOnLine">
	              	<img src="../assets/images/icon_retreat_selected.png"/><br/>
	              	已接收
	              </span>  
                <span @click="retreat($event,index,item.SN)" v-else-if="item.AlarmStatus==7">
                  <img src="../assets/images/icon_retreat.png"/><br/>
                  已接收
                </span>  
                <span @click="retreat($event,index,item.SN)" v-else-if="((AllRetreatFlag==true && AllRetreatOnLineSN[item.SN]) || (GroupRetreatFlag==group && GroupRetreatOnLineSN[item.SN]) || IsTrereatState[index]==true) && !item.isOnLine">
                  <img src="../assets/images/icon_retreat_selected.png" /><br/>
                  已发送
                </span> 
                <span @click="retreat($event,index,item.SN)" v-else-if="(AllRetreatFlag==true && AllRetreatOnLineSN[item.SN]) || (GroupRetreatFlag==group && GroupRetreatOnLineSN[item.SN]) || IsTrereatState[index]==true">
                  <img src="../assets/images/icon_retreat.png"/><br/>
                  已发送
                </span>  
                </span>   
              	<span @click="retreat($event,index,item.SN)" v-else-if="!IsTrereatState[index] && !item.isOnLine">
              		<img src="../assets/images/icon_retreat2.png"/><br/>
              		未发送
              	</span>  
                <span @click="retreat($event,index,item.SN)" v-else>
                  <img src="../assets/images/icon_retreat.png"/><br/>
                  未发送
                </span>   
              	<font v-if="item.IsInside">内攻</font>
              	<div style="clear: both;"></div>  
              </div>
            </template> 

            <!-- 呼救器信息 -->
            <div :class="{'off-line':item.isOnLine}">
            	<p>
            		<img src="../assets/images/home_icon_ecco_notonline.png" v-if="item.isOnLine"/>
            		<img src="../assets/images/home_icon_ecco.png" v-else/>互救器
            	</p>
            	<ul>
            		<li>
            			<template v-if="item.isOnLine">
	            			<img src="../assets/images/home_icon_battery_full-notonline.png" /><br/> 
	            			<font>设备电量</font> 
            			</template>
            			<template v-else-if="item.ICUEle>75">
	            			<img src="../assets/images/home_icon_battery_full.png" /><br/>
	            			<font class="red" v-if="item.ICUEle<=ConfigList.EquipmentBattery">设备电量</font>
	            			<font v-else>设备电量</font> 
            			</template>
            			<template v-else-if="item.ICUEle>50">
	            			<img src="../assets/images/home_icon_battery_three.png" /><br/>
	            			<font class="red" v-if="item.ICUEle<=ConfigList.EquipmentBattery">设备电量</font>
	            			<font v-else>设备电量</font> 
            			</template>
            			<template v-else-if="item.ICUEle>25">
	            			<img src="../assets/images/home_icon_battery_two.png" /><br/>
	            			<font class="red" v-if="item.ICUEle<=ConfigList.EquipmentBattery">设备电量</font>
	            			<font v-else>设备电量</font> 
            			</template>
            			<template v-else>
	            			<img src="../assets/images/home_icon_battery_alert.png" /><br/> 
	            			<font class="red" v-if="item.ICUEle<=ConfigList.EquipmentBattery">设备电量</font>
	            			<font v-else>设备电量</font> 
            			</template>
            		</li>
            		<li> 
            			<template v-if="item.isOnLine">
	            			<img src="../assets/images/home_icon_recco_notonline.png"/><br/>
	            			<font>离线</font>
            			</template>
            			<template v-else-if="item.AlarmStatus==3">
	            			<img src="../assets/images/home_icon_recco_manualalert.png"/><br/>
	            			<font>手动报警</font>
            			</template>
            			<template v-else-if="item.AlarmStatus==4">
	            			<img src="../assets/images/home_icon_recco_alarmstrong.png"/><br/>
	            			<font>预报警</font>
            			</template>
            			<template v-else-if="item.AlarmStatus==6 || item.AlarmStatus==7">
	            			<img src="../assets/images/home_icon_recco_strongalert.png"/><br/>
	            			<font v-if="item.AlarmStatus==6">强报警</font>
                    <font v-if="item.AlarmStatus==7">后撤报警</font>
            			</template>
            			<template v-else>
	            			<img src="../assets/images/icon_alarm_normal_64.png"/><br/>
	            			<font>正常</font>
            			</template>
            		</li>

            		<li class="padtop" :class="{red:!item.isOnLine && item.Temperature > ConfigList.AmbienTemperature}"> 
            			{{item.Temperature==null ? '-' : item.Temperature}} °C<br/>
            			环境温度
            		</li>

            		<li class="padtop" :class="{red:item.DepartDuration_AI!=null && item.DepartDuration_AI!=undefined && item.DepartDuration_AI/60 > ConfigList.TimeOfDeparture}">  
                  <template>
                    {{workState(item)}}
                    
                  </template> 
            			<br/> 
                  {{item.DepartDuration_AI==null || item.DepartDuration_AI==undefined ? '工作时长' : '出发时长'}}
            			
            		</li>
            		<li class="padtop">
            			{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}} 米<br/>
            			{{item.RelativelyHigh == null ?'海拔高度':'相对高度'}}
            		</li>
            	</ul>
            </div> 
 
            <div> 
              <!-- 空呼气瓶信息 -->
              <div class="left" :class="{'off-line':item.isOnLine || !item.GASIsOnLine}">
                <p>
                  <img src="../assets/images/home_icon_oxygen_notonline.png" v-if="item.isOnLine || !item.GASIsOnLine"/>
                  <img src="../assets/images/home_icon_oxygen.png" v-else/>空呼气瓶
                </p>
                <ul>
                  <li>
                    <template v-if="item.isOnLine || !item.GASIsOnLine">
                      <img src="../assets/images/home_icon_battery_full-notonline.png" /><br/> 
                      <font>设备电量</font>  
                    </template>
                    <template v-else-if="item.GASEle>75">
                      <img src="../assets/images/home_icon_battery_full.png" /><br/>
                      <font class="red" v-if="item.GASEle<=ConfigList.EquipmentBattery">设备电量</font>
                      <font v-else>设备电量</font>  
                    </template>
                    <template v-else-if="item.GASEle>50">
                      <img src="../assets/images/home_icon_battery_three.png" /><br/>
                      <font class="red" v-if="item.GASEle<=ConfigList.EquipmentBattery">设备电量</font>
                      <font v-else>设备电量</font>  
                    </template>
                    <template v-else-if="item.GASEle>25">
                      <img src="../assets/images/home_icon_battery_two.png" /><br/>
                      <font class="red" v-if="item.GASEle<=ConfigList.EquipmentBattery">设备电量</font>
                      <font v-else>设备电量</font>  
                    </template>
                    <template v-else>
                      <img src="../assets/images/home_icon_battery_alert.png" /><br/>
                      <font class="red" v-if="item.GASEle<=ConfigList.EquipmentBattery">设备电量</font>
                      <font v-else>设备电量</font>  
                    </template>
                  </li> 
                  <li class="padtop" :class="{red:!item.isOnLine && item.GASIsOnLine && item.GASPressure <= ConfigList.CallPressure}"> 
                    {{item.GASPressure==null ? '-' : item.GASPressure}} MPa<br/>
                    空呼余量
                  </li> 
                  <li class="padtop" :class="{red:!item.isOnLine && item.GASIsOnLine && item.GASRemainingTime <= ConfigList.CallRemainingTime}"> 
                    {{item.GASRemainingTime==null ? '-' : item.GASRemainingTime}} min<br/>
                    剩余时长
                  </li> 
                </ul>
              </div> 

              <!-- 耳机手环信息 -->
              <div class="right" style="border-bottom: 0;" :class="{'off-line':item.isOnLine || item.Device == undefined || item.Device == 0}">
                <p style="padding-left: 6px">
                  <img src="../assets/images/home_icon_bracelet_notonline.png" v-if="item.isOnLine || item.Device==undefined || item.Device == 0"/>
                  <img src="../assets/images/home_icon_bracelet.png" v-else/>耳机/手环  
                </p>
                <ul>
                  <li>
                    <template v-if="item.isOnLine || item.Device==undefined || item.Device == 0">
                      <img src="../assets/images/home_icon_battery_full-notonline.png" /><br/> 
                      <font>设备电量</font> 
                    </template>
                    <template v-else-if="item.DeviceEle>75">
                      <img src="../assets/images/home_icon_battery_full.png" /><br/>
                      <font class="red" v-if="item.DeviceEle <= ConfigList.EquipmentBattery">设备电量</font>
                      <font v-else>设备电量</font> 
                    </template>
                    <template v-else-if="item.DeviceEle>50">
                      <img src="../assets/images/home_icon_battery_three.png" /><br/>
                      <font class="red" v-if="item.DeviceEle<=ConfigList.EquipmentBattery">设备电量</font>
                      <font v-else>设备电量</font> 
                    </template>
                    <template v-else-if="item.DeviceEle>25">
                      <img src="../assets/images/home_icon_battery_two.png" /><br/>
                      <font class="red" v-if="item.DeviceEle<=ConfigList.EquipmentBattery">设备电量</font>
                      <font v-else>设备电量</font> 
                    </template>
                    <template v-else>
                      <img src="../assets/images/home_icon_battery_alert.png" /><br/>
                      <font class="red" v-if="item.DeviceEle<=ConfigList.EquipmentBattery">设备电量</font>
                      <font v-else>设备电量</font> 
                    </template>
                  </li>  
                  <li class="padtop" :class="{red: !item.isOnLine && item.Device != 0 && (item.DeviceHeartRate>ConfigList.TeamHeartRateMax || item.DeviceHeartRate<ConfigList.TeamHeartRateMin)}"> 
                    {{item.DeviceHeartRate==null ? 0: item.DeviceHeartRate}} bpm<br/>
                    队员心率 
                  </li> 
                </ul>
              </div> 
            </div>  
            <div>  
              <!-- 定位器信息 --> 
              <div class="left" :class="{'off-line':item.isOnLine || item.Location.isOnLine || JSON.stringify(item.Location)=='{}'}">
                <p>
                  <img src="../assets/images/home_icon_locator_notonline.png" v-if="item.isOnLine || item.Location.isOnLine || JSON.stringify(item.Location)=='{}'"/>
                  <img src="../assets/images/home_icon_locator.png" v-else/>定位器 
                </p>
                <ul>
                  <li>  
                    <template v-if="item.isOnLine || item.Location.isOnLine || JSON.stringify(item.Location)=='{}'">
                      <img src="../assets/images/home_icon_battery_full-notonline.png" /><br/> 
                      <font>设备电量</font> 
                    </template>
                    <template v-else-if="item.Location.TrackElec>75">
                      <img src="../assets/images/home_icon_battery_full.png" /><br/>
                      <font class="red" v-if="item.Location.TrackElec<=ConfigList.EquipmentBattery">设备电量</font>
                      <font v-else>设备电量</font> 
                    </template>
                    <template v-else-if="item.Location.TrackElec>50">
                      <img src="../assets/images/home_icon_battery_three.png" /><br/>
                      <font class="red" v-if="item.Location.TrackElec<=ConfigList.EquipmentBattery">设备电量</font>
                      <font v-else>设备电量</font> 
                    </template> 
                    <template v-else-if="item.Location.TrackElec>25">
                      <img src="../assets/images/home_icon_battery_two.png" /><br/>
                      <font class="red" v-if="item.Location.TrackElec<=ConfigList.EquipmentBattery">设备电量</font>
                      <font v-else>设备电量</font> 
                    </template>
                    <template v-else>
                      <img src="../assets/images/home_icon_battery_alert.png" /><br/> 
                      <font class="red" v-if="item.Location.TrackElec<=ConfigList.EquipmentBattery">设备电量</font>
                      <font v-else>设备电量</font> 
                    </template>
                  </li> 
                  <li class="padtop">  
                    {{(item.FloorNumber==0 || item.FloorNumber==null || item.FloorNumber==undefined)?'-':item.FloorNumber}}<br/>
                    当前层
                  </li>
                  <li class="padtop"> 
                    {{'-'}} 米<br/>
                    总路程
                  </li> 
                </ul>
              </div> 

              <!-- 耳机手环信息 -->
            	<div class="right" :class="{'off-line':item.isOnLine || item.Device==undefined || item.Device != 2}"> 
	            	<ul> 
                  <li class="padtop" 
                    :class="{'red': !item.isOnLine && item.Device == 2 && item.DeviceTemperature < ConfigList.BodySurfaceTemperatureMin}"> 
                    {{item.DeviceTemperature==null ? '-' : item.DeviceTemperature}} °C<br/>
                    队员体温 
                  </li>    
                  <li class="padtop" 
                    :class="{'red': !item.isOnLine && item.Device == 2 && item.DeviceBloodOxygen < ConfigList.BloodOxygenMin}"> 
                    {{item.DeviceBloodOxygen==null?'-':item.DeviceBloodOxygen}} %<br/>
                    血氧浓度
                  </li> 
	            	</ul>
            	</div> 
            </div> 


            <!-- 气体检测仪信息 -->
            <div v-if="item.GasDetectorIsOnLine" :class="{'off-line':item.isOnLine}">
              <p> 
                <img src="../assets/images/home_icon_ecco.png" style="visibility: hidden;"/>气体检测仪
              </p>
              <ul>
                <li> 
                  <template v-if="item.isOnLine">
                    <img src="../assets/images/home_icon_battery_full-notonline.png" /><br/> 
                    <font>设备电量</font>  
                  </template>
                  <template v-else-if="item.GasDetectorEle>75">
                    <img src="../assets/images/home_icon_battery_full.png" /><br/>
                    <font class="red" v-if="item.GasDetectorEle<=ConfigList.EquipmentBattery">设备电量</font>
                    <font v-else>设备电量</font> 
                  </template>
                  <template v-else-if="item.GasDetectorEle>50">
                    <img src="../assets/images/home_icon_battery_three.png" /><br/>
                    <font class="red" v-if="item.GasDetectorEle<=ConfigList.EquipmentBattery">设备电量</font>
                    <font v-else>设备电量</font> 
                  </template>
                  <template v-else-if="item.GasDetectorEle>25">
                    <img src="../assets/images/home_icon_battery_two.png" /><br/>
                    <font class="red" v-if="item.GasDetectorEle<=ConfigList.EquipmentBattery">设备电量</font>
                    <font v-else>设备电量</font> 
                  </template>
                  <template v-else>
                    <img src="../assets/images/home_icon_battery_alert.png" /><br/> 
                    <font class="red" v-if="item.GasDetectorEle<=ConfigList.EquipmentBattery">设备电量</font>
                    <font v-else>设备电量</font> 
                  </template>
                </li>
                <li class="padtop"> 
                  {{item.CarbonMonoxide==undefined ? '-' : item.CarbonMonoxide}} PPM<br/>
                  一氧化碳
                </li>
                <li class="padtop"> 
                  {{item.Oxygen==undefined ? '-' : item.Oxygen}} %VOL<br/>
                  氧气
                </li>
                <li class="padtop"> 
                  {{item.CombustibleGas==undefined ? '-' : item.CombustibleGas}} %LEL<br/>
                  可燃气体
                </li> 
                <li class="padtop"> 
                  {{item.HydrogenSulfide==undefined ? '-' : item.HydrogenSulfide}} PPM<br/>
                  硫化氢
                </li>
              </ul>
            </div>  

          </a-collapse-panel>
        </a-collapse>
         
        
        <div class="home-add-team" v-else>
      		<div>
	      		<img src="../assets/images/team_img_info_none.png" />
	      		<p>暂无上线队员 请添加</p>
	      		<router-link tag="button" to="/allteam">添加队员</router-link>   
      		</div>
      	</div> 
        <div class="load-box" style="position: absolute;width: 100%;height: 100%;z-index: 2;top: 0;left: 0;background:#576371; text-align: center;">
          <img src="../assets/load-img.gif" style="width:20%;margin-top: 100%" v-show="loadImg">
          <a id="load-btn" @click="resetLoadData" style="display:none;color:#fff; font-size: 20px;margin-top: 100%;">点击重新加载</a>
        </div>
        
      </a-col>
      <a-col style="width:67%;float: left;" class="home-iframe">
        <iframe
        	id="page3d" 
          title="page3d"
          name="page3d"
          src="3D/index.html"
          style="width: 100%; height: 100%; float: right;"
        ></iframe>
      </a-col>
    </a-row> 
 
    <button class="rescue-btn" @click="rescue" v-if="rescueBtn">搜救</button>
    <button class="rescue-btn" v-else style="background: #ccc">搜救</button>

    <!-- 点击队员图标显示的详细信息 -->
    <transition name="fade">  
	    <div class="team-boxs" v-if="monitBox">  
	    	<h3 :class="{'off-line': TeamMember.isOnLine}">
	    		<img src="../assets/images/icon_search_helmet_offline.png" v-if="TeamMember.isOnLine"/> 
      		<img src="../assets/images/icon_search_helmet_alarmstrong.png" v-else-if="TeamMember.AlarmStatus==6 || TeamMember.AlarmStatus==3"/>
      		<img src="../assets/images/icon_search_helmet_alarmpre.png" v-else-if="TeamMember.AlarmStatus==4"/> 
      		<img src="../assets/images/icon_search_helmet_normal.png" v-else/> 
	    		<span v-if="TeamMember.isOnLine">
	    			{{TeamMember.GroupName}}<br/>
	    			{{TeamMember.Name}}  
	    		</span>
	    		<span v-else-if="TeamMember.AlarmStatus==6 || TeamMember.AlarmStatus==3" :class="{red:isColor}">
	    			{{TeamMember.GroupName}}<br/>
	    			{{TeamMember.Name}}
	    		</span>
	    		<span v-else-if="TeamMember.AlarmStatus==4" :class="{yellow:isColor}">
	    			{{TeamMember.GroupName}}<br/>
	    			{{TeamMember.Name}}
	    		</span>
	    		<span v-else :class="{green:isColor}">
	    			{{TeamMember.GroupName}}<br/>
	    			{{TeamMember.Name}}
	    		</span> 
	    		<div>  
	    			<!-- 呼救器状态 -->
	    			<img src="../assets/images/icon_alarm_notonline_64.png" v-if="TeamMember.isOnLine" style="float:right;"/>  
	      		<img src="../assets/images/icon_search_alarmstrong_prepare.png" v-else-if="TeamMember.AlarmStatus==4" style="float:right;"/> 
	      		<img src="../assets/images/icon_alarmstrong_64.png" v-else-if="TeamMember.AlarmStatus==6 || TeamMember.AlarmStatus==3" style="float:right;"/> 
		    		<img src="../assets/images/icon_alarm_normal_64.png" v-else style="float:right;"/>
		    		<br> 

            <!--高度-->
		    		<img src="../assets/images/icon_height_64.png" v-if="TeamMember.isOnLine"/> 
            <img src="../assets/images/icon_height_yellow_64.png" v-else-if="TeamMember.AlarmStatus==4"/>
            <img src="../assets/images/icon_alarmstrong_height_64.png" v-else-if="TeamMember.AlarmStatus==6 || TeamMember.AlarmStatus==3"/> 
            <img src="../assets/images/icon_height_green_64.png" v-else/>

            <font v-if="TeamMember.isOnLine" :class="{'off-line':isColor}">{{TeamMember.RelativelyHigh == null ? TeamMember.Altitude : TeamMember.RelativelyHigh}}</font>
            <font v-else-if="TeamMember.AlarmStatus == 6 || TeamMember.AlarmStatus== 3" :class="{red:isColor}">{{TeamMember.RelativelyHigh == null ? TeamMember.Altitude : TeamMember.RelativelyHigh}}</font> 
            <font v-else-if="TeamMember.AlarmStatus == 4" :class="{yellow:isColor}">{{TeamMember.RelativelyHigh == null ? TeamMember.Altitude : TeamMember.RelativelyHigh}}</font> 
            <font v-else :class="{green:isColor}">{{TeamMember.RelativelyHigh == null ? TeamMember.Altitude : TeamMember.RelativelyHigh}}</font>  

	    		</div>
	    	</h3>
	    	<!--气瓶-->
	    	<div class="monit-box-data monit-box-data-left" :class="{'off-line':TeamMember.isOnLine || !TeamMember.GASIsOnLine}"> 

          <div class="home-bottle" v-if="TeamMember.isOnLine || !TeamMember.GASIsOnLine"> 
          </div>
          <div class="home-bottle" v-else :style="{backgroundPosition:getPosition(TeamMember.GASPressure)}"> 
          </div>  

	    		<span v-if="TeamMember.isOnLine || !TeamMember.GASIsOnLine">
		    		<strong>{{TeamMember.GASRemainingTime==null ? '-' : TeamMember.GASRemainingTime}}</strong>min<br/>
		    		<strong>{{TeamMember.GASPressure==null ? '-' : TeamMember.GASPressure}}</strong>MPa
	    		</span> 
	    		<span v-else-if="TeamMember.GASPressure<=6" :class="{red:isColor}">
		    		<strong>{{TeamMember.GASRemainingTime==null ? '-' : TeamMember.GASRemainingTime}}</strong>min<br/>
            <strong>{{TeamMember.GASPressure==null ? '-' : TeamMember.GASPressure}}</strong>MPa
	    		</span>
          <span v-else-if="TeamMember.GASPressure<=10" :class="{yellow:isColor}">
            <strong>{{TeamMember.GASRemainingTime==null ? '-' : TeamMember.GASRemainingTime}}</strong>min<br/>
            <strong>{{TeamMember.GASPressure==null ? '-' : TeamMember.GASPressure}}</strong>MPa
          </span>
          <span v-else :class="{green:isColor}">
            <strong>{{TeamMember.GASRemainingTime==null ? '-' : TeamMember.GASRemainingTime}}</strong>min<br/>
            <strong>{{TeamMember.GASPressure==null ? '-' : TeamMember.GASPressure}}</strong>MPa
          </span>
	    	</div>
	    	<div class="monit-box-data monit-box-data-right">
	    		<ul>
	    			<li>
	    				<!--呼救器-->
	    				<img src="../assets/images/icon_recco_notonline_64.png" v-if="TeamMember.isOnLine"/>

              <img src="../assets/images/Recco-red.png" v-else-if="TeamMember.ICUEle <  ConfigList.EquipmentBattery"/>
	    				<img src="../assets/images/icon_recco_normal_64.png" v-else/>  


	    				<img src="../assets/images/home_icon_battery_full-notonline.png" v-if="TeamMember.isOnLine"/>
	    				<img src="../assets/images/home_icon_battery_full.png" v-else-if="TeamMember.ICUEle>75"/>
	    				<img src="../assets/images/home_icon_battery_three.png" v-else-if="TeamMember.ICUEle>50"/>
	    				<img src="../assets/images/home_icon_battery_two.png" v-else-if="TeamMember.ICUEle>25"/>
	    				<img src="../assets/images/home_icon_battery_alert.png" v-else-if="TeamMember.ICUEle>0"/>
	    			</li>
	    			<li>
	    				<!--手环--> 
	    				<img src="../assets/images/icon_bracelet_notonline_64.png" v-if="TeamMember.isOnLine || !TeamMember.Device || TeamMember.Device != 1"/>

              <img src="../assets/images/Loop-red.png" v-else-if="TeamMember.DeviceEle < ConfigList.EquipmentBattery"/> 
	    				<img src="../assets/images/icon_bracelet_normal_64.png" v-else/> 

	    				<img src="../assets/images/home_icon_battery_full-notonline.png" v-if="TeamMember.isOnLine || !TeamMember.Device || TeamMember.Device != 1"/> 
	    				<img src="../assets/images/home_icon_battery_full.png" v-else-if="TeamMember.DeviceEle>75"/>
	    				<img src="../assets/images/home_icon_battery_three.png" v-else-if="TeamMember.DeviceEle>50"/>
	    				<img src="../assets/images/home_icon_battery_two.png" v-else-if="TeamMember.DeviceEle>25"/>
	    				<img src="../assets/images/home_icon_battery_alert.png" v-else-if="TeamMember.DeviceEle>0"/>
	    			</li>
	    		</ul>
	    		<ul style="margin-bottom:5px;">
	    			<li style="float:left;width:50%">
	    				<!--温度显示-->
	    				<img src="../assets/images/icon_search_temperature_notonline.png" v-if="TeamMember.isOnLine"/> 
	    				<img src="../assets/images/icon_alarmsrong_temperature_64.png" v-else-if="TeamMember.Temperature>ConfigList.AmbienTemperature"/> 
	    				<img src="../assets/images/icon_search_temperature_green_big.png" v-else/> 
	    				<font v-if="TeamMember.isOnLine" :class="{'off-line':isColor}">{{TeamMember.Temperature}} °C</font>
	    				<font v-else-if="TeamMember.Temperature>ConfigList.AmbienTemperature" :class="{'red':isColor}">{{TeamMember.Temperature}} °C</font>
	    				<font v-else :class="{'green':isColor}">{{TeamMember.Temperature}} °C</font>
	    			</li>
	    			<li style="float:left;width:50%">
	    				<!--体温显示--> 
	    				<img src="../assets/images/icon_temperature_notonline.png" v-if="TeamMember.isOnLine || TeamMember.Device==undefined || TeamMember.Device != 2"/>
              <img src="../assets/images/icon_temperature_notonline.png" v-else-if="TeamMember.DeviceTemperature==null"/>  
              <img src="../assets/images/icon_temperature_red.png" v-else-if="TeamMember.DeviceTemperature < ConfigList.BodySurfaceTemperatureMin"/>   
              <img src="../assets/images/icon_temperature_green.png" v-else/>  
              
              <font v-if="TeamMember.isOnLine || TeamMember.Device==undefined || TeamMember.Device != 2" :class="{'off-line':isColor}">{{TeamMember.DeviceTemperature==null?'-':TeamMember.DeviceTemperature+' °C'}}</font> 
              <font v-else-if="TeamMember.DeviceTemperature< ConfigList.BodySurfaceTemperatureMin" :class="{'red':isColor}">{{TeamMember.DeviceTemperature}} °C</font>   
              <font v-else :class="{'green':isColor}">{{TeamMember.DeviceTemperature}} °C</font> 

	    			</li>

            <li style="float:left;width:50%">
              <!--心率显示--> 
              <img src="../assets/images/icon_heart_notonline_64.png" v-if="TeamMember.isOnLine || TeamMember.Device == 0 || TeamMember.Device==undefined"/>

              <img src="../assets/images/Heart-red.png" v-else-if="TeamMember.DeviceHeartRate > ConfigList.TeamHeartRateMax || TeamMember.DeviceHeartRate < ConfigList.TeamHeartRateMin"/>  

              <img src="../assets/images/icon_heart_normal_64.png" v-else/>  

              <font v-if="TeamMember.isOnLine || TeamMember.Device == 0 || TeamMember.Device==undefined" :class="{'off-line':isColor}">{{TeamMember.DeviceHeartRate==null?0:TeamMember.DeviceHeartRate}}bpm</font> 

              <font v-else-if="TeamMember.DeviceHeartRate > ConfigList.TeamHeartRateMax || TeamMember.DeviceHeartRate < ConfigList.TeamHeartRateMin" :class="{'red':isColor}">{{TeamMember.DeviceHeartRate==null?0:TeamMember.DeviceHeartRate}}bpm</font>

              <font v-else :class="{'green':isColor}">{{TeamMember.DeviceHeartRate==null?0:TeamMember.DeviceHeartRate}}bpm</font> 
            </li>

            <li style="float:left;width:50%">
              <!--血氧显示-->  

              <img src="../assets/images/icon_blood_notonline.png" v-if="TeamMember.isOnLine || TeamMember.Device==undefined || TeamMember.Device != 2"/>
              <img src="../assets/images/icon_blood_notonline.png" v-else-if="TeamMember.DeviceBloodOxygen==null"/>  
              <img src="../assets/images/icon_blood_red.png" v-else-if="TeamMember.DeviceBloodOxygen < ConfigList.BloodOxygenMin"/>   
              <img src="../assets/images/icon_blood_green.png" v-else/>  
              <font v-if="TeamMember.isOnLine || TeamMember.Device==undefined || TeamMember.Device != 2" :class="{'off-line':isColor}">{{TeamMember.DeviceBloodOxygen==null?'-':TeamMember.DeviceBloodOxygen+' %'}}</font>   
              <font v-else-if="TeamMember.DeviceBloodOxygen < ConfigList.BloodOxygenMin" :class="{'red':isColor}">{{TeamMember.DeviceBloodOxygen}} %</font>   
              <font v-else :class="{'green':isColor}">{{TeamMember.DeviceBloodOxygen}} %</font> 
            </li>


	    			<li>
	    				<!--WorkTime-->
	    				<img src="../assets/images/icon_search_time_ontonline.png" v-if="TeamMember.isOnLine"/> 

              <img src="../assets/images/time-red.png" v-else-if="TeamMember.WorkTime > ConfigList.TimeOfDeparture"/> 

	    				<img src="../assets/images/time_red_64.png" v-else/> 

	    				<font v-if="TeamMember.isOnLine" :class="{'off-line':isColor}">{{TeamMember.WorkTime}} min</font> 
              <font v-else-if="TeamMember.WorkTime > ConfigList.TimeOfDeparture" :class="{'red':isColor}">{{TeamMember.WorkTime}} min</font> 
	    				<font v-else :class="{green:isColor}">{{TeamMember.WorkTime}} min</font>
	    			</li>
	    		</ul>
	    	</div>
	    </div>
    </transition>
    <div class="mask" @click="closeCall" v-if="monitBox"></div>   

  	<retreat :show="isRetreat" :msg="retreatMsg" @ok="okRetreat" @cancal="cancalRetreat"></retreat>
  	<prompt :show="isPrompt" @okPrompt="okPrompt" @cancalPrompt="cancalPrompt"></prompt>
    <reset v-if="isReset" :location="locationData" @okReset="okReset" @cancalReset="cancalReset" @reset="teamReset"></reset>

  </div> 
</template>

<script>
import { Component, Vue } from "vue-property-decorator"; 
import { Button } from "ant-design-vue"; 
import Retreat from "../components/retreat"; 
import Reset from "../components/reset"; 
import Prompt from "../components/prompt"; 
import HomeService from "../api/HomeService"; 
import AllTeamService from "../api/AllTeamService"; 
Vue.component(Button.name, Button);  
Vue.config.productionTip = false;  

export default {
	inject: ["reload"],
  name: "Home",
  data() {
    return { 
      groupName:[],//组别名称
      groups:[],//点击选中的组别
      group:'',
      index:0,
      groupIndex:0,//点击选中的组别对应的索引
      monitBox:false,
      TeamMember:{},
      isColor:true,
      isRetreat:false,
      isPrompt:false,
      isGroupRetreat:false,
      SN:'',
      retreatMsg:'',  
      stateIndex:0, 
      record:{},//轨迹数据
      historyRecord:{},//历史轨迹数据
      recordOne:true,//true时加载轨迹历史，否则实施更新
      buildAll:false,//3D模型加载完成后的标识 
      isLoadBuild:false,
      isLoadHistory:false,
      detailAlertIndex:0, 
      newRecord:{},
      callState:[], 
      isOnLine:true,
      isTrereatState:{},
      detailIndex:0,
      clearInter:null,
      groupRetreatImg:false,
      isResponseState:[],
      rescueBtn:false,
      isOneLoad:true,
      isCalibrationPage:false,
      nullLocationSpotData:{}, 
      TeamMemberLists:[], 
      setInterval:null,  
      floors:[],
      downTime:null,
      startX:0,
      startY:0,
      endX:0,
      endY:0,
      currentGroupIndex:0,
      loadImg:true,
      isReset:false,
      locationData:[],
      resetSN:'' 
    };
  },
  created() {  
    this.getAllTeamList() 
     

    //callState用来监听队员掉线的时候发送状态给地图
    for (var i = 0; i < 20; i++) { 
      this.callState.push({emergency:''}) 
    }
    sessionStorage.setItem('isHistoryRecord',false) 
  	window.addEventListener("message", this.correcting) 
  },
  mounted(){     
		let that = this 
		setTimeout(()=>{  
      if(document.getElementById('page3d')){ 
  		 	document.getElementById('page3d').onload=function(){   


          if(that.$route.params.lnglat){ 
            HomeService.ResetLastLoadData().then(
              res => {
                if (res.status == 1000) { 
                  //this.$message.success("清除成功"); 
                } else {
                  this.$message.warning(res.message);
                }
              },
              err => { 
                this.$message.warning(err.message);
              }
            );
            let setMap={
              type:'setMapCenter',
              data:that.$route.params.lnglat
            }  
            document.getElementById('page3d').contentWindow.postMessage(setMap, '/')
          }else{

            //建筑显示
            //如果是从建筑列表过来的就会有携带楼层信息
            if(that.$route.params.floorData != undefined){ 
              let buildData = JSON.parse(that.$route.params.floorData.JsonData) 
              sessionStorage.build2D=that.$route.params.floorData.JsonData
              if(Object.keys(buildData).length != 0){
                buildData.type = 'to3DSave'
              } 
              document.getElementById('page3d').contentWindow.postMessage(buildData, '/') 
              let clearTime = setInterval(()=>{ 
                if(that.TeamMemberLists.length>0){ 
                  that.floors = buildData.floors 
                  sessionStorage.floors = JSON.stringify(buildData.floors)
                  that.getHistoryRecord()
                  clearInterval(clearTime)
                }
              },80)
            }else{  
              HomeService.getLastLoadData().then(
                res => { 
                  if (res.status == 200) {
                    if (res.data.status == 1000) {   
                      let buildData = JSON.parse(res.data.data)    

                      sessionStorage.build2D=res.data.data
                      if(Object.keys(buildData).length != 0){
                        buildData.type = 'to3DSave'
                      } 
                      document.getElementById('page3d').contentWindow.postMessage(buildData, '/') 
                      let clearTime = setInterval(()=>{ 
                        if(that.TeamMemberLists != null){
                          if(that.TeamMemberLists.length>0){  
                            that.floors = buildData.floors 
                            sessionStorage.floors = JSON.stringify(buildData.floors)
                            that.getHistoryRecord()
                            clearInterval(clearTime)
                          }
                        } 
                      },80) 
                    } else {
                      let troopInfo = that.$store.state.troopInfo
                      let setMap={
                        type:'setMapCenter',
                        data:{lng:troopInfo.AmapLng,lat:troopInfo.AmapLat}
                      }  
                      document.getElementById('page3d').contentWindow.postMessage(setMap, '/')
                    }
                  } else {
                    that.$message.warning(res.message)
                  }
                },
                err => {
                  that.$message.warning(err.message) 
                }
              )  
            }
          }

  	  		
  	  		//打开高度校准输入框
  	  		document.getElementById('page3d').contentWindow.document.body.onclick=function(e){
  	  			if(e.target.id=='height-calibration'){
  	  				that.isPrompt=true
  	  			}
  	  		}


          document.getElementById('page3d').contentWindow.addEventListener('mousedown',function(e){  
            that.downTime = new Date().getTime() 
          },true) 
  	  		
  	  		document.getElementById('page3d').contentWindow.addEventListener('mouseup',function(e){  
  	  		 if(new Date().getTime() - that.downTime<130) 
  		    	if(e.target.getAttribute('style') == 'width:50px;height:50px'){  
  		  			that.call(sessionStorage.snData)
  		  		}
  		    },false)   
  		 	}
      }
		},0)   
    
     
    this.setInterval = setInterval(()=>{
      this.intervalCheckOnline()
    },60000) 
    
  }, 
  beforeDestroy(){ 
    clearInterval(this.setInterval) 
  },
  methods:{  
    getAllTeamList(){    
      if(this.$store.state.TeamMemberLists==undefined || !this.$store.state.TeamMemberLists.length){
        AllTeamService.getAllTeamList().then(
          res => {
            if (res.status == 200 && res.data.status == 1000) {   
              this.$store.commit("setTeamMemberLists", res.data.data); 
              this.getTroopsTeamMemberStatus()
            } else if (res.status == 200) {
              this.$message.warning(res.data.msg);
            } else {
              this.$message.warning(res.message);
            }
          },
          err => {  
            if (err && err.stack.indexOf('timeout') > -1) {  
               this.getAllTeamList()
            }else{
              this.$message.warning(err.message)
            } 
          }
        )
      }else{
        this.getTroopsTeamMemberStatus()
      }    
    }, 
    resetLoadData(){
      this.getTroopsTeamMemberStatus(true)
    },
    getTroopsTeamMemberStatus(isOne){
      if(isOne){
        this.loadImg=true
        document.getElementById('load-btn').style.display='none'
      } 
      //首次进来获取队员信息
      //清空上一次的组别 
      HomeService.getTroopsTeamMemberStatus().then( 
        res => {
            document.getElementsByClassName('load-box')[0].style.display='none'  
            if (res.status == 200) {
              if(res.data.status == 1000) {   
                for (var i = 0; i <res.data.data.length; i++) {  

                  //获取组别  
                  if(res.data.data.length && this.groups.indexOf(res.data.data[i].GroupName) =='-1'){  
                    this.groups.push(res.data.data[i].GroupName) 
                  } 
                  //默认显示第一组的队员  
                  this.group = this.groups[0]    
                }  
                //TeamMemberLists为队员信息，后续操作都是TeamMemberLists  
                this.TeamMemberLists = this.$store.state.TeamMemberLists  
                this.getReccoTeamMemberList(res.data.data)
                //搜救页面需要用到组别
                this.$store.commit('setTeamMemberGroups', this.groups) 
                //60秒检查一次队员是否掉线 
                this.intervalCheckOnline()
                //是否显示搜救按钮，需有队员报警才显示
                this.isShowRescue() 
                
              } else {
                this.$message.warning(res.data.msg)
              }
            } else {
              this.$message.warning(res.message)
            }
        },
        err => {  
          if (err && err.stack.indexOf('timeout') > -1) { 
            this.$message.warning('连接超时')
            this.loadImg=false
            document.getElementById('load-btn').style.display='inline-block'
            //this.getTroopsTeamMemberStatus()
             
          }else{
            this.$message.warning(err.message)
          } 
        }  
      ) 
    },
    touchSatrt(e){
      let touch=e.touches[0]  
      this.startX = touch.pageX           
      this.startY = touch.pageY 
    },
    touchMove(e){
      let touch = e.touches[0]             
      this.endX = this.startX - touch.pageX 
      this.endY = this.startY - touch.pageY    
    },
    touchEnd(){   
      if(this.endX < -20 && this.endY < 30){
        if(this.currentGroupIndex>0){
          this.currentGroupIndex--
          this.getTeamByGroup(this.groups[this.currentGroupIndex],this.currentGroupIndex)
        } 
      }else if(this.endX > 20 && this.endY < 30){ 
        if(this.currentGroupIndex<this.groups.length-1){
          this.currentGroupIndex++ 
          this.getTeamByGroup(this.groups[this.currentGroupIndex],this.currentGroupIndex)
        } 
      }
    },
    isShowRescue(){
      //如果有报警的就显示搜救按钮 
      for(let i=0;i<(this.TeamMemberLists==null?0:this.TeamMemberLists.length);i++){
        if(this.TeamMemberLists[i].AlarmStatus == 3 || this.TeamMemberLists[i].AlarmStatus == 6 && this.TeamMemberLists[i].isOnLine==false){  
            this.rescueBtn = true
            break
        }else{
            this.rescueBtn = false
        }
      }
    },
    intervalCheckOnline(){   
      for (var i = 0; i < (this.TeamMemberLists==null?0:this.TeamMemberLists.length); i++) {   
        if(this.TeamMemberLists[i].UDTime ==undefined || parseInt(new Date(this.getTimes()) - new Date(this.TeamMemberLists[i].UDTime))/1000 > 65){  
          Vue.set(this.TeamMemberLists[i],'isOnLine',true)  


          //掉线了发送状态给地图 
          if(this.record.data != undefined){
            for (var j = 0; j < this.record.data.length; j++) { 
              if('S' + this.record.data[j].sn == this.TeamMemberLists[i].SN){  
                this.callState[j].emergency=99 
                this.record.data[j].emergency = 3
                
              }
            }
          }   
        }else{  
          Vue.set(this.TeamMemberLists[i],'isOnLine',false)
        } 

        if(this.TeamMemberLists[i].Location == undefined || JSON.stringify(this.TeamMemberLists[i].Location)=='{}'){  
          Vue.set(this.TeamMemberLists[i],'Location',{})  
 

        }else{ 

          if(parseInt(new Date(this.getTimes()) - new Date(this.getTimes(new Date(this.TeamMemberLists[i].Location.UDTime.toString().replace(/\T/g," ").replace(/\Z/g," ")).getTime())))/1000 > 65){  
            Vue.set(this.TeamMemberLists[i].Location,'isOnLine',true)  
          }else{        
            Vue.set(this.TeamMemberLists[i].Location,'isOnLine',false)
          }
        }

         
      } 
    }, 
  	correcting(event){   
  		let data = event.data.data 
  		switch (event.data.type) {
	      case 'calibration':   
	      	this.isLoadBuild=false
		 			this.isLoadHistory=false
	      	//校准   

          /*HomeService.loadCalibration({Type:"save",Data:event.data.data}).then(
            res => { 
              if (res.status == 200) {
                if (res.data.status == 1000) { 
                  //console.log('成功')
                } else {
                  this.$message.warning(res.data.msg)
                }
              } else {
                this.$message.warning(res.message) 
              } 
            },
            err => {
              this.$message.warning(err.message)
            }
          )*/


          
          let calibrations=[]
          for(let i=0;i<data.length;i++){
            calibrations.push({sn:'S'+data[i].sn,x:data[i].ox,y:data[i].oy,angle:data[i].angle})
          }     
					HomeService.manualCalibration(calibrations).then(
		  			res => { 
			        if (res.status == 200) {
			          if (res.data.status == 1000) { 
			          	this.$message.success("校准成功")
                  this.isCalibrationPage = false
                  document.getElementsByClassName('rescue-btn')[0].style.display='block'
                  //console.log("校准成功") 
			          	document.getElementById('page3d').contentWindow.postMessage({type:'calibration'}, '/') 
			          } else {
			          	this.$message.warning(res.data.msg)
			          }
			        } else {
			        	this.$message.warning(res.message) 
			        } 
			      },
			      err => {
			        this.$message.warning(err.message)
			      }
		  		) 
	      break;  
	      case 'InitCalibration':  
	      	this.isLoadBuild=false
		 			this.isLoadHistory=false
	      	//初始点校准 
          HomeService.heightCalibration({FloorNumber:event.data.floorNum}).then(
            res => { 
              if (res.status == 200) {
                if (res.data.status == 1000) {  

                  HomeService.initCorrecting({x:data.x/7.25,y:data.y/7.25,angle:data.angle}).then(
                    res => { 
                      if (res.status == 200) {
                        if (res.data.status == 1000) {  
                          this.isCalibrationPage = false
                          this.$message.success("校准成功") 
                          document.getElementsByClassName('rescue-btn')[0].style.display='block'
                          document.getElementById('page3d').src=' 3D/index.html'
                         
                          //document.getElementById('page3d').contentWindow.postMessage({type:'initCalibration'}, '/') 
                        } else {
                          this.$message.warning(res.data.msg)
                        }
                      } else {
                        this.$message.warning(res.message)
                      } 
                    },
                    err => {
                      this.$message.warning(err.message)
                    }
                  )


                }else {
                  this.$message.warning(res.data.msg)
                }
              } else {
                this.$message.warning(res.message)
              } 
            },
            err => {
              this.$message.warning(err.message)
            } 
          ) 
	      break; 
	    	case 'cancalCalibration': 
          this.isCalibrationPage = false  
	    		this.isLoadBuild=false
		 			this.isLoadHistory=false
          if(document.getElementsByClassName('rescue-btn')[0] != undefined){
            document.getElementsByClassName('rescue-btn')[0].style.display='block'
          }
	    	break; 
	    	case 'cancalInitCalibration':
          this.isCalibrationPage = false
	    		this.isLoadBuild=false
		 			this.isLoadHistory=false 
          if(document.getElementsByClassName('rescue-btn')[0] != undefined){
            document.getElementsByClassName('rescue-btn')[0].style.display='block'
          }
	    	break;
        case 'hideBtn':  
          this.isCalibrationPage=true
          setTimeout(()=>{  
            document.getElementById('page3d').contentWindow.postMessage(this.record, '/')
          },1100)

          if(data == 'initialPointCalibration'){
            HomeService.getTroopsTotalOffset().then(
              res => { 
                if (res.status == 200) {
                  if (res.data.status == 1000) {    
                    let floorNum = 1
                    if(res.data.data){
                      floorNum =res.data.data.FloorNum
                    }   

                    setTimeout(()=>{
                      document.getElementById('page3d').contentWindow.postMessage({type:'getTroopsTotalOffset',data:floorNum}, '/')
                    },500) 
                  } 
                } else {
                  that.$message.warning(res.message)
                }
              },
              err => {
                that.$message.warning(err.message) 
              }
            ) 
          }else if(data == 'calibration'){
            HomeService.getTroopsLocationList().then(
              res => { 
                if (res.status == 200) {
                  if (res.data.status == 1000) {   
                    
                    let record = []  
                    let index = 0    
                    if(res.data.data.length){ 
                      for (let i = 0; i < this.TeamMemberLists.length; i++) {
                        for (let j = 0; j < res.data.data.length; j++) {
                          
                          if(this.TeamMemberLists[i].SN == res.data.data[j].SN && this.TeamMemberLists[i].isInit){  

                            let recordObj={}
                            recordObj.index = index
                            recordObj.sn = this.TeamMemberLists[i].SN.replace(/[^0-9]/ig,"")
                            recordObj.name = this.TeamMemberLists[i].Name
                             
                            recordObj.geos = res.data.data[j].Geos
                            recordObj.floor = this.TeamMemberLists[i].FloorNumber==0?'-': this.TeamMemberLists[i].FloorNumber

                            if(this.TeamMemberLists[i].isOnLine){
                              recordObj.emergency = 3
                            }else{
                              if(this.TeamMemberLists[i].AlarmStatus == 6 || this.TeamMemberLists[i].AlarmStatus == 3 || this.TeamMemberLists[i].AlarmStatus == 7){
                                recordObj.emergency = 2
                              }else if(this.TeamMemberLists[i].AlarmStatus == 4){
                                recordObj.emergency = 1
                              }else{
                                recordObj.emergency = 0
                              }
                            } 
                            index++ 
                            record.push(recordObj)
                          }

                        }
                      }


                    }  

                    sessionStorage.record=JSON.stringify(record) 
                    document.getElementById('page3d').contentWindow.postMessage({type:'calibrationHistoryRecord'}, '/')     


                  } else {
                    //that.$message.warning(res.data.msg)
                  }
                } else {
                  that.$message.warning(res.message)
                }
              },
              err => {
                that.$message.warning(err.message) 
              }
            ) 
          }


          

          if(document.getElementsByClassName('rescue-btn')[0] != undefined){
            document.getElementsByClassName('rescue-btn')[0].style.display='none'
          }

          
          
        break;
        case 'updateHead': 
          setTimeout(()=>{
            //document.getElementById('page3d').contentWindow.postMessage(this.record, '/')
          },1100) 
        break;
        case 'loadCalibration': 
          HomeService.loadCalibration({"Type":"read"}).then(
            res => { 
              if (res.status == 200) {
                if (res.data.status == 1000) {  
                  document.getElementById('page3d').contentWindow.postMessage({type:'loadCalibration',data:JSON.parse(res.data.data)}, '/')  
                  
                } else {
                  this.$message.warning(res.data.msg)
                }
              } else {
                this.$message.warning(res.message)
              }
            },
            err => {
              this.$message.warning(err.message) 
            }
          )
        break; 
	    } 
 


  	},
  	//高度校准事件
  	okPrompt(param){ 
      if(param < this.floors[0].start || param >this.floors[this.floors.length-1].end){
        this.$message.warning("超出楼层，请重新输入")
      }else{
        HomeService.heightCalibration({FloorNumber:param}).then(
          res => { 
            if (res.status == 200) {
              if (res.data.status == 1000) {   
                this.$message.success("初始楼层设置成功") 
                this.isPrompt=false
              } else {
                this.$message.warning(res.data.msg)
              }
            } else {
              this.$message.warning(res.message)
            }
          },
          err => {
            this.$message.warning(err.message) 
          }
        ) 
      } 
  	},
    clickReset(){ 
      this.locationData=[]
      for (var i = 0; i < this.TeamMemberLists.length; i++) { 
        if(JSON.stringify(this.TeamMemberLists[i].Location) !=='{}'){ 
          this.locationData.push(this.TeamMemberLists[i])
        }
      } 
      if(this.locationData.length){
        this.isReset=true
      }else{
        this.$message.warning('没有定位器已上线的队员')
      }
    },
    okReset(){ 
      this.isRetreat=true  
      this.retreatMsg='是否确定进行信息重置？'
    },
    cancalReset(){
      this.isReset=false
    },
    teamReset(sn,name){  
      this.resetSN = sn
      this.isRetreat=true  
      this.retreatMsg='队员 <strong style="color:#40DC23">'+name+'</strong> 即将重置？'
    },
  	//关闭高度校准框
  	cancalPrompt(){
  		this.isPrompt=false
  	},
  	//撤退提示框弹出
  	retreat(e,index,SN){
  		e.stopPropagation()
  		this.stateIndex = index

      if(SN.length != 11){
        SN='S0'+SN
      }

  		this.SN = SN
  		this.isRetreat=true 
  		this.isGroupRetreat=true
  		this.retreatMsg='是否发出撤退命令？'
  	},
  	okRetreat(){
      if(this.isReset){
        //定位器重置
        if(this.retreatMsg == '是否确定进行信息重置？'){

          HomeService.memberLocationReset({
            "resetType":2
          }).then(
            res => { 
              if (res.status == 200) {
                if (res.data.status == 1000) {  
                  //this.$message.success("重置成功") 
                } else {
                  this.$message.warning(res.data.msg)
                }
              } else {
                this.$message.warning(res.message)
              }
            },
            err => {
              this.$message.warning(err.message) 
            }
          ) 

 
        }else{
          HomeService.memberLocationReset({
            "resetType":1,
            "value":this.resetSN
          }).then(
            res => { 
              if (res.status == 200) {
                if (res.data.status == 1000) {  
                  //this.$message.success("重置成功") 
                } else {
                  this.$message.warning(res.data.msg)
                }
              } else {
                this.$message.warning(res.message)
              }
            },
            err => {
              this.$message.warning(err.message) 
            }
          )  
        }  
        this.isRetreat=false
      }else{
        //个人撤退 
        if(this.isGroupRetreat){   
          this.$store.commit('setIsResponse', {type:false,data:this.SN}) 
          this.isRetreat=false 
          this.$message.success("已发送") 
          HomeService.memberWithdraw({withdrawType:1,value:this.SN}).then(
            res => { 
              if (res.status == 200) {
                if (res.data.status == 1000) {  
                  this.$store.commit('setIsTrereatState',this.stateIndex)  
                  /*this.$success({
                    title: '提示',
                    content: '撤退成功',
                    okText:"确定",
                    centered:true,
                  }) */   
                } else {
                  this.$message.warning(res.data.msg)
                }
              } else {
                this.$message.warning(res.message)
              }
            },
            err => {
              this.$message.warning(err.message) 
            }
          ) 
        }else{
          //组撤退
          let paramObj={withdrawType:2,value:this.group}  

          for (var i = 0; i < this.TeamMemberLists.length; i++) {  
              this.$store.commit('setGroupRetreatOnLineSN', this.TeamMemberLists[i].SN)
          
            if(this.TeamMemberLists[i].GroupName == this.group){  
              this.$store.commit('setIsResponse', {type:false,data:this.TeamMemberLists[i].SN})
            } 
          } 
          this.isRetreat=false
          this.groupRetreatImg=true
          this.$message.success("已发送") 
          HomeService.memberWithdraw(paramObj).then(
            res => { 
              if (res.status == 200) {
                if (res.data.status == 1000) {   
                  this.$store.commit('setGroupRetreatFlag',this.group)
                  
                  
                } else {
                  this.$message.warning(res.data.msg)
                }
              } else {
                this.$message.warning(res.message)
              }
            },
            err => {
              this.$message.warning(err.message) 
            }
          )
        } 
      }


  		
  	},
  	//关闭撤退提示框
  	cancalRetreat(){
  		this.isRetreat=false
  	},
  	groupRetreat(){ 
  		this.isGroupRetreat=false
  		this.isRetreat=true  
  		this.retreatMsg='是否发出组撤命令？' 
  	},
  	//掉线超过十秒下线
  	timeDrop(t){
  		if(t!=null){  
  			return parseInt( new Date(this.getTimes()) - new Date(this.getTimes(t.UpdateTime)))/1000 >60
  		}else{
  			return true
  		}
  	},
  	closeSos(){
  		setTimeout(()=>{
  			this.showSOS = false
  		},400)
  		
  	},
  	call(sn){  
  		let tempsn = sn 
  		if(tempsn==undefined){
  			return 
  		} else if(tempsn.indexOf('N') == -1){
        tempsn = sn.slice(0,1) + 'N' + sn.slice(1) 
      }
      clearInterval(this.clearInter)  
  		for(let i=0;i<this.TeamMemberLists.length;i++){ 
  			if(tempsn.substring(2) == this.TeamMemberLists[i].SN.substring(1)){
          this.detailIndex=i
  				this.TeamMember = this.TeamMemberLists[this.detailIndex]
  				this.clearInter = setInterval(()=>{ 
  					this.TeamMember = this.TeamMemberLists[this.detailIndex]  
  				},2000) 

  				this.monitBox=true 
  			}
  		}
       
  	},
  	closeCall(){
  		this.monitBox=false
  	},
  	getTeamByGroup(group,index){  
      this.group=group  
  		this.groupIndex = index   
  	}, 
    rescue(){
      if(document.getElementsByClassName('team-info')[0] != undefined){  
        for (var i = 0; i < this.TeamMemberLists.length; i++) {
          if(this.TeamMemberLists[i].AlarmStatus == 3 || this.TeamMemberLists[i].AlarmStatus == 6 && !this.TeamMemberLists[i].isOnLine){ 
            this.$router.push({ 
              name: 'rescue',
              query:{
                sn:this.TeamMemberLists[i].SN,
                group:this.TeamMemberLists[i].GroupName, 
                /*relativeHeight:this.TeamMemberLists[i].RelativelyHigh==null || this.TeamMemberLists[i].RelativelyHigh==undefined?this.TeamMemberLists[i].Altitude:this.TeamMemberLists[i].RelativelyHigh,
                index:this.groupIndex*/
              }
            }).catch(err => {console.error(err)})
            break
          }
        }

      }else{
        this.$message.warning('没有需要搜救的队员')
      } 
    },
  	getTimes(data,type){
		  var _data = data; 
		  //如果是13位正常，如果是10位则需要转化为毫秒
		  if(data ==undefined){
		  	const time = new Date();   
			  const Y = time.getFullYear()
			  const Mon = time.getMonth() + 1
			  const Day = time.getDate()
			  const H = time.getHours()
			  const Min = time.getMinutes()
			  const S = time.getSeconds()
			  return `${Y}/${Mon}/${Day} ${H}:${Min}:${S}`
		  }else{
		  	if (String(data).length == 13) {
			    _data = data
			  } else {
			    _data = data*1000
			  } 
			  const time = new Date(_data)    
			  const Y = time.getFullYear()
			  const Mon = time.getMonth() + 1
			  const Day = time.getDate()
			  const H = time.getHours()
			  const Min = time.getMinutes()
			  const S = time.getSeconds() 
			  if(type=="Y"){
			    return `${Y}-${Mon}-${Day}`
			  }else if(type=="H"){
			    return `${H}:${Min}:${S}`
			  }else{
			    return `${Y}/${Mon}/${Day} ${H}:${Min}:${S}`
			  }
		  }  
		},
		getHistoryRecord(){
			///获取历史轨迹  
      HomeService.getTroopsLocationList().then(
        res => { 
          if (res.status == 200) {
            if (res.data.status == 1000) {
              
              let record = []  
              let index = 0    
              if(res.data.data.length){ 
                for (let i = 0; i < this.TeamMemberLists.length; i++) {
                  for (let j = 0; j < res.data.data.length; j++) { 
                    if(this.TeamMemberLists[i].SN == res.data.data[j].SN && this.TeamMemberLists[i].isInit){    
                      //获取楼层信息
                      let floorNumber = this.getFloors(this.floors,this.TeamMemberLists[i])  
                      Vue.set(this.TeamMemberLists[i],'FloorNumber', floorNumber==undefined?'-':floorNumber) 
                      //获取轨迹信息
                      let recordObj={}
                      recordObj.index = index
                      recordObj.sn = this.TeamMemberLists[i].SN.replace(/[^0-9]/ig,"")
                      recordObj.name = this.TeamMemberLists[i].Name

                     
                   
                      recordObj.geos = res.data.data[j].Geos


                      recordObj.floor = this.TeamMemberLists[i].FloorNumber==0?'-': this.TeamMemberLists[i].FloorNumber
                      if(this.TeamMemberLists[i].isOnLine){
                        recordObj.emergency = 3
                      }else{
                        if(this.TeamMemberLists[i].AlarmStatus == 6 || this.TeamMemberLists[i].AlarmStatus == 3 || this.TeamMemberLists[i].AlarmStatus == 7){
                          recordObj.emergency = 2
                        }else if(this.TeamMemberLists[i].AlarmStatus == 4){
                          recordObj.emergency = 1
                        }else{
                          recordObj.emergency = 0
                        }
                      } 
                      index++  
                      record.push(recordObj)
                    } 
                  }  
                } 
              }   

  



              sessionStorage.record=JSON.stringify(record)  
 
              this.record = {type:'updateRecord', data:record}   
 
              if(document.getElementById('page3d')!=null){ 
                document.getElementById('page3d').contentWindow.postMessage({type:'historyRecord',data:record}, '/')
              } 
              
              let interval = setInterval(()=>{ 
                if(sessionStorage.getItem('isHistoryRecord')=='true'){ 
                  this.isLoadBuild=true
                  this.isLoadHistory=true     
                  
                  clearInterval(interval)
                }  
              },100) 
            } else {
              //that.$message.warning(res.data.msg)
            }
          } else {
            that.$message.warning(res.message)
          }
        },
        err => {
          that.$message.warning(err.message) 
        }
      ) 
		}, 
		getFloors(floors,teamMemberList){    
      if(!floors.length){
        return
      }    
      let Altitude 
      if(teamMemberList.Location && teamMemberList.Location.Z != null){ 
        Altitude = teamMemberList.Location.Z
      }else{  
        Altitude = 0
      } 
 

      let floorsArr=[] 
      let total=0
      let floor=0  
      let firstFloorHeight=0
      let flag=false
      let isPositive=true  
      let index=0 
      for (var i = 0; i < floors.length; i++) { 
        for(var j = floors[i].start; j <= floors[i].end; j++){ 
          if(j != 0){ 
            let floorsObj={}
            if(floors[0].start　< 0){
              isPositive=false
            }
            if(floors[0].start == j && Altitude >= 0){  
              floorsObj.high = floors[i].high * 0.8
              firstFloorHeight = floors[i].high - floors[i].high * 0.8
            }else if(floors[0].start == j && Altitude < 0){ 
              floorsObj.high = floors[i].high * 1.2
              firstFloorHeight = floors[i].high * 1.2 - floors[i].high
            }else{
              floorsObj.high = floors[i].high
            }
            
            floorsObj.floor = j
            floorsArr.push(floorsObj)
          } 
        }
      }    

      if(Altitude>=0){
        for (let i = 0; i < floorsArr.length; i++) {
          if(floorsArr[i].floor>0){ 
            if(isPositive){ 
              total += floorsArr[i].high
            }else{    
              if(index==0){    
                total += floorsArr[i].high-firstFloorHeight
              }else{  
                total += floorsArr[i].high
              }
              
            } 
            index++
            floor++ 
            if(isPositive){
              if(Altitude < total){  
                return floor
              }
            }else{
              if(Altitude <= total){  
                return floor
              }
            }
              
          }  
        }
        if(floorsArr[floorsArr.length-1].floor<0){ 
          return floorsArr[floorsArr.length-1].floor
        } 
        if(Altitude > total){  
          return floor
        }
      }else{
        for (let i = 0; i < floorsArr.length; i++) {
          
          if(floorsArr[i].floor<0){  
            flag=true 
            if(Altitude > -firstFloorHeight){
              return 1
            }
            total -= floorsArr[i].high
            floor -- 
            if(Altitude > total){  
              return floor
            }
          } 
        } 
        if(Altitude < total){   
          if(flag) {
            return floor 
          }else{
            return floor+1 
          }
          
        }
      }
    }, 
		
		//监听最新轨迹刷新
		getTeamMemberList2SN(newValue,name){    
      let newIndex=-1      

			let newRecord  = []
			
			for(let i=0;i<this.TeamMemberLists.length;i++){ 
				let newRecordObj={}   
    		if(newValue.SN == this.TeamMemberLists[i].SN && this.TeamMemberLists[i].isInit){   
    			newRecordObj.index = newIndex 
					newRecordObj.sn = this.TeamMemberLists[i].SN.replace(/[^0-9]/ig,"")
					newRecordObj.name = name   
					 
          let newValueZ = newValue.Z == 0 ? newValue.OffsetCoordinate.Z : newValue.Z
					newRecordObj.geos = [{x: newValue.X, y: newValue.Y, z: newValue.Z}]
        

          let floorNumber = this.getFloors(this.floors,this.TeamMemberLists[i])  
          Vue.set(this.TeamMemberLists[i],'FloorNumber', floorNumber==undefined?'-':floorNumber)  
					
          newRecordObj.floor = this.TeamMemberLists[i].FloorNumber==0?'-':this.TeamMemberLists[i].FloorNumber


          if(this.TeamMemberLists[i].isOnLine){ 
             newRecordObj.emergency = 3
          }else{
            if(this.TeamMemberLists[i].AlarmStatus == 6 || this.TeamMemberLists[i].AlarmStatus == 3 || this.TeamMemberLists[i].AlarmStatus == 7){
              newRecordObj.emergency = 2
            }else if(this.TeamMemberLists[i].AlarmStatus == 4){
              newRecordObj.emergency = 1
            }else{ 
              newRecordObj.emergency = 0
            }
          }
					
					newRecord.push(newRecordObj) 

          //添加到record列表中队员初次上线才能改变报警状态
          if(this.record.data){
            let recordSNArr=[] 
            for (let j = 0; j < this.record.data.length; j++) { 
              recordSNArr.push(this.record.data[j].sn) 
            } 
            if(recordSNArr.indexOf(newRecordObj.sn) == -1){ 
              this.record.data.push(newRecordObj)
            }
          }
          
		  	}    
    	}   

      this.newRecord = {type:'updateRecord', data:newRecord} 
			if(this.isLoadHistory && this.isLoadBuild){   
				document.getElementById('page3d').contentWindow.postMessage(this.newRecord, '/')
			}  
    },

    getReccoList2SN(newValue,name){ 

      if(Object.keys(this.newRecord).length!=0){
        for (var i = 0; i < this.newRecord.data.length; i++) {
          if('S'+this.newRecord.data[i].sn == newValue.SN){
            return
          }
        }
      }
      
 
      let newIndex=1     
      let newRecord  = [] 
      for(let i=0;i<this.TeamMemberLists.length;i++){ 
        let newRecordObj={}   
        if(newValue.SN == this.TeamMemberLists[i].SN && this.TeamMemberLists[i].isInit){   
          newRecordObj.index = newIndex 
          newRecordObj.sn = this.TeamMemberLists[i].SN.replace(/[^0-9]/ig,"")
          newRecordObj.name = name  
          //呼救器没有gps信号时不设置地图坐标显示
          if(newValue.GPSLong ==undefined || newValue.GPSLat==undefined){
            return
          }
          newRecordObj.lng =  newValue.GPSLong
          newRecordObj.lat =  newValue.GPSLat
          newRecordObj.high =  newValue.GPAHigh
            
          newRecordObj.geos = [{x:0, y: 0, z: 0}]
        

          let floorNumber = this.getFloors(this.floors,this.TeamMemberLists[i])  
          Vue.set(this.TeamMemberLists[i],'FloorNumber', floorNumber==undefined?'-':floorNumber)  

          

          newRecordObj.floor = this.TeamMemberLists[i].FloorNumber==0?'-':this.TeamMemberLists[i].FloorNumber


          if(this.TeamMemberLists[i].isOnLine){ 
             newRecordObj.emergency = 3
          }else{
            if(this.TeamMemberLists[i].AlarmStatus == 6 || this.TeamMemberLists[i].AlarmStatus == 3 || this.TeamMemberLists[i].AlarmStatus == 7){
              newRecordObj.emergency = 2
            }else if(this.TeamMemberLists[i].AlarmStatus == 4){
              newRecordObj.emergency = 1
            }else{ 
              newRecordObj.emergency = 0
            }
          }
          
          newRecord.push(newRecordObj) 

          //添加到record列表中队员初次上线才能改变报警状态
          if(this.record.data){
            let recordSNArr=[] 
            for (let j = 0; j < this.record.data.length; j++) { 
              recordSNArr.push(this.record.data[j].sn) 
            } 
            if(recordSNArr.indexOf(newRecordObj.sn) == -1){ 
              this.record.data.push(newRecordObj)
            }
          }
          
        }    
      }    
      this.newHead = {type:'showHead', data:newRecord}   
      document.getElementById('page3d').contentWindow.postMessage(this.newHead, '/')
       
    }, 


    getReccoTeamMemberList(to){  
  
      for (var i = 0; i < (this.TeamMemberLists==null?0:this.TeamMemberLists.length); i++) {    

        if(to.constructor===Array){
          for (var j = 0; j < to.length; j++) {
            if(to[j].SN == this.TeamMemberLists[i].SN){   
              //获取组别信息   
              if(this.groups.indexOf(this.TeamMemberLists[i].GroupName) =='-1'){  
                this.groups.push(this.TeamMemberLists[i].GroupName) 
              } 
              this.$store.commit('setTeamMemberGroups', this.groups) 
              //呼救器信息  
              Vue.set(this.TeamMemberLists[i],'UDTime',to[j].UDTime)
              Vue.set(this.TeamMemberLists[i],'SN',to[j].SN)
              Vue.set(this.TeamMemberLists[i],'AlarmStatus',to[j].AlarmStatus)   
              Vue.set(this.TeamMemberLists[i],'Temperature',to[j].Temperature)
              Vue.set(this.TeamMemberLists[i],'ICUEle',to[j].ICUEle)
              Vue.set(this.TeamMemberLists[i],'WorkTime',to[j].WorkTime)
              Vue.set(this.TeamMemberLists[i],'ICUVolt',to[j].ICUVolt) 

              //Vue.set(this.TeamMemberLists[i],'DepartDuration',to[j].DepartDuration)
              //Vue.set(this.TeamMemberLists[i],'DepartDuration_AI',to[j].DepartDuration_AI)
              Vue.set(this.TeamMemberLists[i],'Altitude',to[j].Altitude)
              //定位置信息
              Vue.set(this.TeamMemberLists[i],'GPSLong',to[j].GPSLong)
              Vue.set(this.TeamMemberLists[i],'GPSLat',to[j].GPSLat)
              Vue.set(this.TeamMemberLists[i],'GPAHigh',to[j].GPAHigh)
              //手环耳机信息
              Vue.set(this.TeamMemberLists[i],'Device',to[j].Device)
              Vue.set(this.TeamMemberLists[i],'DeviceEle',to[j].DeviceEle)
              Vue.set(this.TeamMemberLists[i],'DeviceHeartRate',to[j].DeviceHeartRate)
              Vue.set(this.TeamMemberLists[i],'DeviceTemperature',to[j].DeviceTemperature)
              Vue.set(this.TeamMemberLists[i],'DeviceBloodOxygen',to[j].DeviceBloodOxygen)
              //空呼气瓶信息
              Vue.set(this.TeamMemberLists[i],'GASPressure',to[j].GASPressure)
              Vue.set(this.TeamMemberLists[i],'GASRemainingTime',to[j].GASRemainingTime)
              Vue.set(this.TeamMemberLists[i],'GASEle',to[j].GASEle)  
              Vue.set(this.TeamMemberLists[i],'isOnLine',false)
              Vue.set(this.TeamMemberLists[i],'isInit',true)
              Vue.set(this.TeamMemberLists[i],'IsInside',to[j].IsInside)
 
            }
          }
        }else{
          
          if(this.TeamMemberLists[i].SN == to.SN){     
            //获取组别信息   
            if(this.groups.indexOf(this.TeamMemberLists[i].GroupName) =='-1'){  
              this.groups.push(this.TeamMemberLists[i].GroupName) 
              this.group = this.TeamMemberLists[i].GroupName
              this.groupIndex = this.groups.indexOf(this.TeamMemberLists[i].GroupName)
            } 
            this.$store.commit('setTeamMemberGroups', this.groups)   

            //定位置信息 
            //let floorNumber = this.getFloors(this.floors,this.TeamMemberLists[i])    
            //Vue.set(this.TeamMemberLists[i],'FloorNumber', floorNumber==undefined?'-':floorNumber) 

      

            //更新图标状态信息   
            if(this.record.data != undefined){
              for (var j = 0; j < this.record.data.length; j++) { 
                
                if('S' + this.record.data[j].sn == to.SN){ 
                
                
                  this.callState[j].emergency=to.AlarmStatus

                  if(to.isOnLine){
                    this.record.data[j].emergency = 3
                  }else{
                    if(to.AlarmStatus == 6 || to.AlarmStatus == 3 || to.AlarmStatus == 7){  
                      this.record.data[j].emergency = 2
                    }else if(to.AlarmStatus == 4){  
                      this.record.data[j].emergency = 1
                    }else{   
                      this.record.data[j].emergency = 0
                    }
                  } 
                  this.record.type= 'updateHead'
                }
              }
            } 

            this.getReccoList2SN(this.TeamMemberLists[i],this.TeamMemberLists[i].Name) 
          }
        } 
      }  
      //如果有报警的就显示搜救按钮    
      this.isShowRescue() 
    },
    secondToTimeStr(t) {
      if (!t) return;
      if (t < 60) return "00:00:" + ((i = t) < 10 ? "0" + i : i);
      if (t < 3600) return "00:" + ((a = parseInt(t / 60)) < 10 ? "0" + a : a) + ":" + ((i = t % 60) < 10 ? "0" + i : i);
      if (3600 <= t) {
      var a, i, e = parseInt(t / 3600);
      return (e < 10 ? "0" + e : e) + ":" + ((a = parseInt(t % 3600 / 60)) < 10 ? "0" + a : a) + ":" + ((i = t % 60) < 10 ? "0" + i : i);
      }
    }
  }, 
  computed: {
    TeamMemberList() {
      return this.$store.state.TeamMemberList  
    }, 
    TroopInfo() {
      return this.$store.state.troopInfo  
    },  
    TeamMemberListType(){
    	return this.$store.state.TeamMemberListType 
    },
    AllRetreatFlag(){
    	return this.$store.state.AllRetreatFlag
    }, 
    AllRetreatOnLineSN(){
      return this.$store.state.AllRetreatOnLineSN
    }, 
    GroupRetreatOnLineSN(){
      return this.$store.state.GroupRetreatOnLineSN
    }, 
    GroupRetreatFlag(){
      return this.$store.state.GroupRetreatFlag
    }, 
    IsTrereatState(){
      return this.$store.state.IsTrereatState
    },
    TeamMemberList2(){ 
    	return this.$store.state.TeamMemberList2
    }, 
    IsResponse(){
      return this.$store.state.IsResponse
    },
    ConfigList() {
      return this.$store.state.Config
    }, 
    getPosition(){
      return function(mpaParams){    
        let mpa = Math.ceil(mpaParams) 
        mpa = mpa>30?30:mpa
        mpa = mpa<0?0:mpa 
        return -mpa*60-mpa+'px 0'  
      }
    }, 
    ReccoTeamMemberList(){
      return this.$store.state.ReccoTeamMemberList
    },
    LocationInfo(){
      return this.$store.state.LocationInfo
    },
    workState: function () {  
      return function(item){  
        if(item.DepartDuration_AI==null){  
          if(!item.WorkTime){ 
            return '00:00:00' 
          }else{ 
            let workTime = (Math.floor(item.WorkTime/60) < 10?'0'+Math.floor(item.WorkTime/60):Math.floor(item.WorkTime/60))+':'+(item.WorkTime%60 < 10 ?'0'+item.WorkTime%60:item.WorkTime%60) + ':00'
            return workTime
          }   
        }else{ 
          return this.secondToTimeStr(item.DepartDuration_AI);
        } 
      } 
    } 
  },
  watch: {  
    ReccoTeamMemberList(to,from){     
      this.getReccoTeamMemberList(to)
    }, 
    LocationInfo(to,from){   
      if(to.X!==undefined && to.Y!==undefined && to.Z!==undefined){ 
        for (var i = 0; i < this.TeamMemberLists.length; i++) {    
          if(this.TeamMemberLists[i].SN == to.SN){     
            //更新定位器数据
            this.getTeamMemberList2SN(to,this.TeamMemberLists[i].Name)

          } 
        } 
      } 
    }, 
  	callState:{
      handler(newName, oldName) { 
        if(this.isLoadHistory && this.isLoadBuild){   
          //报警状态更改了发送数据
          //console.log('已发送')  
          document.getElementById('page3d').contentWindow.postMessage(this.record, '/')  
          
        }
      },  
      deep: true 
    } 
  },
  destroyed(){
		window.removeEventListener("message",this.correcting)
	},
  components: {
    Retreat,
    Prompt,
    Reset
  }
}
</script>
<style lang="less"> 
  

</style>

